import { isWebGPUSupported } from "@tensorflow/tfjs-backend-webgpu/dist/webgpu_util"
import { UAParser } from "my-ua-parser"
import { detectBrowserCapabilities } from "@/store/app/browser-capabilities"

function testWebGLSupport(contextId: "webgl" | "experimental-webgl" | "webgl2") {
	if (typeof document === "undefined") return false
	const canvas = document.createElement("canvas")
	const gl = canvas.getContext(contextId)

	return !!gl
}

function detectIsDesktopDevice() {
	if (typeof navigator === "undefined" || typeof window === "undefined") {
		return false
	}

	if (typeof window.matchMedia === "function" && window.matchMedia("(pointer: coarse)").matches) {
		return false
	}

	// iPadOS 13+ reports its UA as desktop Safari on Mac but still has multi-touch.
	const ua = navigator.userAgent ?? ""
	if (/Macintosh/.test(ua) && (navigator.maxTouchPoints ?? 0) > 1) {
		return false
	}

	const deviceType = UAParser().device.type
	if (deviceType === "mobile" || deviceType === "tablet") {
		return false
	}

	return true
}

const capabilities = detectBrowserCapabilities()

export const browserCompatibility = {
	screen: detectIsDesktopDevice(),
	webGL: testWebGLSupport("webgl"),
	webGL2: testWebGLSupport("webgl2"),
	webGPU: (() => {
		try {
			return isWebGPUSupported()
		} catch {
			return false
		}
	})(),
	hasFileSystemAccess: capabilities.hasFileSystemAccess,
	hasOPFS: capabilities.hasOPFS,
	supportsSampleOnly: capabilities.supportsSampleOnly,
} as const

/** Whether the device meets the minimum requirements to run the editor. */
export const isDeviceCompatible =
	browserCompatibility.screen && browserCompatibility.webGL && browserCompatibility.webGL2
